import { apiClient as api } from "./httpClient";

/** País do catálogo do tenant; `callingCode` é o DDI só com dígitos (nulo = sem código próprio). */
export interface Country {
  id: string;
  country: string;
  isActive: boolean;
  slug: string | null;
  callingCode: string | null;
  iso2: string | null;
}

// Catálogo estável: uma leitura por sessão da página basta para todos os campos de telefone.
let phoneCountriesCache: Promise<Country[]> | null = null;

export const countriesService = {
  list: async (): Promise<Country[]> => {
    const response = await api.get("/countries");
    return response.data;
  },

  /** Só países com DDI, para o seletor dos telefones. Falha não fica em cache. */
  phoneCountries: (): Promise<Country[]> => {
    phoneCountriesCache ??= countriesService
      .list()
      .then((all) => all.filter((c) => Boolean(c.callingCode)))
      .catch((error: unknown) => {
        phoneCountriesCache = null;
        throw error;
      });
    return phoneCountriesCache;
  },
};
